module.exports = __webpack_public_path__ + "img/tracking.d93b23f0.svg";